export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=608d0edcaa1973ee3bae2251f982c551743f4acf26&name=fetchTypeahead!'